import eventBus from "@/eventBus";
import { debounce } from "@/utils";
import defaultImg from "@/assets/caterpillar.gif";

// 使用IntersectionObserver
const imgs = new Map();
const ob = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    const t = entry.target;
    if (entry.isIntersecting && imgs.has(t)) {
      const src = imgs.get(t);
      const tempImg = new Image();
      tempImg.onload = function () {
        t.src = src;
        ob.unobserve(t);
        imgs.delete(t);
      };
      tempImg.src = src;
    }
  });
});
// 使用事件总线
// let imgs = [];
// function setImage(img) {
//   img.dom.src = defaultImg;
//   // 开始处理
//   const rect = img.dom.getBoundingClientRect();
//   const clientHight = document.documentElement.clientHeight;
//   const height = rect.height || 100;
//   if (rect.top >= -height && rect.top <= clientHight) {
//     const tempImg = new Image();
//     tempImg.onload = function () {
//       img.dom.src = img.src;
//       imgs = imgs.filter((i) => i !== img);
//     };
//     tempImg.src = img.src;
//     // 已处理
//   }
// }
// // 调用后，加载应该加载的图片
// function setImages() {
//   imgs.forEach(setImage);
// }
// // 继续往后加载
// function handleScroll(dom) {
//   setImages();
// }
// eventBus.$on("mainScroll", debounce(handleScroll, 50));
// 指令维护数组
export default {
  inserted(el, binding) {
    // const img = {
    //   dom: el,
    //   src: binding.value,
    // };
    el.src = defaultImg;
    ob.observe(el);
    imgs.set(el, binding.value);
    // setImage(img);
  },
  unbind(el, binding) {
    ob.unobserve(el);
    imgs.delete(el);
  },
};
